export const ui = {
  showModal: ''
};